export default "https://cdn-static.gokick.com/assets/fd6b0a6afc37e3a7e4b7ae7c7f4dd4a202138084/images/gokick-home-thumb.d0805bfbe5c122bc4415664ec8f6d56b.png";